// Authentication
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST'
export const LOGOUT_RESPONSE = 'LOGOUT_RESPONSE'
export const LOGOUT_RESPONSE_ERROR = 'LOGOUT_RESPONSE_ERROR'
export const LOAD_AUTH = 'LOAD_AUTH'

// Organization
export const LIST_ORGANIZATIONS_REQUEST = 'LIST_ORGANIZATIONS_REQUEST'
export const LIST_ORGANIZATIONS_RESPONSE = 'LIST_ORGANIZATIONS_RESPONSE'
export const LIST_ORGANIZATIONS_RESPONSE_ERROR = 'LIST_ORGANIZATIONS_RESPONSE_ERROR'
export const FETCH_ORGANIZATION_REQUEST = 'FETCH_ORGANIZATION_REQUEST'
export const FETCH_ORGANIZATION_RESPONSE = 'FETCH_ORGANIZATION_RESPONSE'
export const CREATE_ORGANIZATION_REQUEST = 'CREATE_ORGANIZATION_REQUEST'
export const CREATE_ORGANIZATION_RESPONSE = 'CREATE_ORGANIZATION_RESPONSE'
export const UPDATE_ORGANIZATION_REQUEST = 'UPDATE_ORGANIZATION_REQUEST'
export const UPDATE_ORGANIZATION_RESPONSE = 'UPDATE_ORGANIZATION_RESPONSE'
export const ADD_ORGANIZATION_USER_REQUEST = 'ADD_ORGANIZATION_USER_REQUEST'
export const ADD_ORGANIZATION_USER_RESPONSE = 'ADD_ORGANIZATION_USER_RESPONSE'
export const ADD_ORGANIZATION_USER_RESPONSE_ERROR = 'ADD_ORGANIZATION_USER_RESPONSE_ERROR'

// Community
export const LIST_COMMUNITIES_REQUEST = 'LIST_COMMUNITIES_REQUEST'
export const LIST_COMMUNITIES_RESPONSE = 'LIST_COMMUNITIES_RESPONSE'
export const LIST_COMMUNITIES_RESPONSE_ERROR = 'LIST_COMMUNITIES_RESPONSE_ERROR'
export const FETCH_COMMUNITY_REQUEST = 'FETCH_COMMUNITY_REQUEST'
export const FETCH_COMMUNITY_RESPONSE = 'FETCH_COMMUNITY_RESPONSE'
export const FETCH_COMMUNITY_RESPONSE_ERROR = 'FETCH_COMMUNITY_RESPONSE_ERROR'
export const SAVE_COMMUNITY_REQUEST = 'SAVE_COMMUNITY_REQUEST'
export const SAVE_COMMUNITY_RESPONSE = 'SAVE_COMMUNITY_RESPONSE'
export const LIST_COMMUNITY_UNITS_REQUEST = 'LIST_COMMUNITY_UNITS_REQUEST'
export const LIST_COMMUNITY_UNITS_RESPONSE = 'LIST_COMMUNITY_UNITS_RESPONSE'
export const LIST_COMMUNITY_UNITS_RESPONSE_ERROR = 'LIST_COMMUNITY_UNITS_RESPONSE_ERROR'
export const UPDATE_ALERT_SUBSCRIPTION_REQUEST = 'UPDATE_ALERT_SUBSCRIPTION_REQUEST'
export const UPDATE_ALERT_SUBSCRIPTION_RESPONSE = 'UPDATE_ALERT_SUBSCRIPTION_RESPONSE'

// Unit
export const LIST_UNITS_REQUEST = 'LIST_UNITS_REQUEST'
export const LIST_UNITS_RESPONSE = 'LIST_UNITS_RESPONSE'
export const FETCH_UNIT_REQUEST = 'FETCH_UNIT_REQUEST'
export const FETCH_UNIT_RESPONSE = 'FETCH_UNIT_RESPONSE'
export const FETCH_UNIT_RESPONSE_ERROR = 'FETCH_UNIT_RESPONSE_ERROR'
export const SAVE_UNIT_REQUEST = 'SAVE_UNIT_REQUEST'
export const SAVE_UNIT_RESPONSE = 'SAVE_UNIT_RESPONSE'
export const SAVE_UNIT_RESPONSE_ERROR = 'SAVE_UNIT_RESPONSE_ERROR'
export const LIST_UNIT_TIMESERIES_REQUEST = 'LIST_UNIT_TIMESERIES_REQUEST'
export const LIST_UNIT_TIMESERIES_RESPONSE = 'LIST_UNIT_TIMESERIES_RESPONSE'
export const LIST_UNIT_DEVICES_REQUEST = 'LIST_UNIT_DEVICES_REQUEST'
export const LIST_UNIT_DEVICES_RESPONSE = 'LIST_UNIT_DEVICES_RESPONSE'

// Timeseries
export const LIST_TIMESERIES_TYPES_REQUEST = 'LIST_TIMESERIES_TYPES_REQUEST'
export const LIST_TIMESERIES_TYPES_RESPONSE = 'LIST_TIMESERIES_TYPES_RESPONSE'
export const SAVE_TIMESERIES_REQUEST = 'SAVE_TIMESERIES_REQUEST'
export const SAVE_TIMESERIES_RESPONSE = 'SAVE_TIMESERIES_RESPONSE'
export const SAVE_TIMESERIES_RESPONSE_ERROR = 'SAVE_TIMESERIES_RESPONSE_ERROR'
export const FETCH_TIMESERIES_REQUEST = 'FETCH_TIMESERIES_REQUEST'
export const FETCH_TIMESERIES_RESPONSE = 'FETCH_TIMESERIES_RESPONSE'
export const FETCH_TIMESERIES_RESPONSE_ERROR = 'FETCH_TIMESERIES_RESPONSE_ERROR'

// Device
export const FETCH_DEVICE_REQUEST = 'FETCH_DEVICE_REQUEST'
export const FETCH_DEVICE_RESPONSE = 'FETCH_DEVICE_RESPONSE'
export const UPDATE_DEVICE_REQUEST = 'UPDATE_DEVICE_REQUEST'
export const UPDATE_DEVICE_RESPONSE = 'UPDATE_DEVICE_RESPONSE'
export const REMOVE_DEVICE_REQUEST = 'REMOVE_DEVICE_REQUEST'
export const REMOVE_DEVICE_RESPONSE = 'REMOVE_DEVICE_RESPONSE'
export const EXECUTE_DEVICE_COMMAND_REQUEST = 'EXECUTE_DEVICE_COMMAND_REQUEST'
export const EXECUTE_DEVICE_COMMAND_RESPONSE = 'EXECUTE_DEVICE_COMMAND_RESPONSE'

// Events
export const LIST_EVENTS_REQUEST = 'LIST_EVENTS_REQUEST'
export const LIST_EVENTS_RESPONSE = 'LIST_EVENTS_RESPONSE'
export const LIST_EVENTS_RESPONSE_ERROR = 'LIST_EVENTS_RESPONSE_ERROR'

// permissions
export const LIST_ROLES_REQUEST = 'LIST_ROLES_REQUEST'
export const LIST_ROLES_RESPONSE = 'LIST_ROLES_RESPONSE'

// Alerts
export const LIST_UNIT_ALERTS_REQUEST = 'LIST_UNIT_ALERTS_REQUEST'
export const LIST_UNIT_ALERTS_RESPONSE = 'LIST_UNIT_ALERTS_RESPONSE'
export const LIST_UNIT_ALERTS_RESPONSE_ERROR = 'LIST_UNIT_ALERTS_RESPONSE_ERROR'
export const LIST_COMMUNITY_ALERTS_REQUEST = 'LIST_COMMUNITY_ALERTS_REQUEST'
export const LIST_COMMUNITY_ALERTS_RESPONSE = 'LIST_COMMUNITY_ALERTS_RESPONSE'
export const LIST_COMMUNITY_ALERTS_RESPONSE_ERROR = 'LIST_COMMUNITY_ALERTS_RESPONSE_ERROR'

// Alert rules
export const LIST_ALERT_TYPES_REQUEST = 'LIST_ALERT_TYPES_REQUEST'
export const LIST_ALERT_TYPES_RESPONSE = 'LIST_ALERT_TYPES_RESPONSE'
export const LIST_ALERT_RULES_REQUEST = 'LIST_ALERT_RULES_REQUEST'
export const LIST_ALERT_RULES_RESPONSE = 'LIST_ALERT_RULES_RESPONSE'
export const SAVE_ALERT_RULE_REQUEST = 'SAVE_ALERT_RULE_REQUEST'
export const SAVE_ALERT_RULE_RESPONSE = 'SAVE_ALERT_RULE_RESPONSE'

// Users
export const LIST_USERS_REQUEST = 'LIST_USERS_REQUEST'
export const LIST_USERS_RESPONSE = 'LIST_USERS_RESPONSE'
export const LIST_USERS_RESPONSE_ERROR = 'LIST_USERS_RESPONSE_ERROR'
export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST'
export const FETCH_USER_RESPONSE = 'FETCH_USER_RESPONSE'
export const FETCH_USER_RESPONSE_ERROR = 'FETCH_USER_RESPONSE_ERROR'

// Access
export const ADD_COMMUNITY_DOOR_ACCESSES_REQUEST = 'ADD_COMMUNITY_DOOR_ACCESSES_REQUEST'
export const ADD_COMMUNITY_DOOR_ACCESSES_RESPONSE = 'ADD_COMMUNITY_DOOR_ACCESSES_RESPONSE'
export const ADD_COMMUNITY_DOOR_ACCESSES_RESPONSE_ERROR = 'ADD_COMMUNITY_DOOR_ACCESSES_RESPONSE_ERROR'
export const ADD_UNIT_DOOR_ACCESSES_REQUEST = 'ADD_UNIT_DOOR_ACCESSES_REQUEST'
export const ADD_UNIT_DOOR_ACCESSES_RESPONSE = 'ADD_UNIT_DOOR_ACCESSES_RESPONSE'
export const ADD_UNIT_DOOR_ACCESSES_RESPONSE_ERROR = 'ADD_UNIT_DOOR_ACCESSES_RESPONSE_ERROR'
export const DISABLE_DOOR_ACCESSES_REQUEST = 'DISABLE_DOOR_ACCESSES_REQUEST'
export const DISABLE_DOOR_ACCESSES_RESPONSE = 'DISABLE_DOOR_ACCESSES_RESPONSE'
export const DISABLE_DOOR_ACCESSES_RESPONSE_ERROR = 'DISABLE_DOOR_ACCESSES_RESPONSE_ERROR'
export const ENABLE_DOOR_ACCESSES_REQUEST = 'ENABLE_DOOR_ACCESSES_REQUEST'
export const ENABLE_DOOR_ACCESSES_RESPONSE = 'ENABLE_DOOR_ACCESSES_RESPONSE'
export const ENABLE_DOOR_ACCESSES_RESPONSE_ERROR = 'ENABLE_DOOR_ACCESSES_RESPONSE_ERROR'
export const FETCH_DOOR_ACCESS_REQUEST = 'FETCH_DOOR_ACCESS_REQUEST'
export const FETCH_DOOR_ACCESS_RESPONSE = 'FETCH_DOOR_ACCESS_RESPONSE'
export const FETCH_DOOR_ACCESS_RESPONSE_ERROR = 'FETCH_DOOR_ACCESS_RESPONSE_ERROR'
export const LIST_COMMUNITY_DOOR_ACCESSES_REQUEST = 'LIST_COMMUNITY_DOOR_ACCESSES_REQUEST'
export const LIST_COMMUNITY_DOOR_ACCESSES_RESPONSE = 'LIST_COMMUNITY_DOOR_ACCESSES_RESPONSE'
export const LIST_COMMUNITY_DOOR_ACCESSES_RESPONSE_ERROR = 'LIST_COMMUNITY_DOOR_ACCESSES_RESPONSE_ERROR'
export const LIST_COMMUNITY_DOOR_ACCESS_IDS_REQUEST = 'LIST_COMMUNITY_DOOR_ACCESS_IDS_REQUEST'
export const LIST_COMMUNITY_DOOR_ACCESS_IDS_RESPONSE = 'LIST_COMMUNITY_DOOR_ACCESS_IDS_RESPONSE'
export const LIST_COMMUNITY_DOOR_ACCESS_IDS_RESPONSE_ERROR = 'LIST_COMMUNITY_DOOR_ACCESS_IDS_RESPONSE_ERROR'
export const LIST_UNIT_DOOR_ACCESS_IDS_REQUEST = 'LIST_UNIT_DOOR_ACCESS_IDS_REQUEST'
export const LIST_UNIT_DOOR_ACCESS_IDS_RESPONSE = 'LIST_UNIT_DOOR_ACCESS_IDS_RESPONSE'
export const LIST_UNIT_DOOR_ACCESS_IDS_RESPONSE_ERROR = 'LIST_UNIT_DOOR_ACCESS_IDS_RESPONSE_ERROR'
export const REMOVE_COMMUNITY_DOOR_ACCESS_REQUEST = 'REMOVE_COMMUNITY_DOOR_ACCESS_REQUEST'
export const REMOVE_COMMUNITY_DOOR_ACCESS_RESPONSE = 'REMOVE_COMMUNITY_DOOR_ACCESS_RESPONSE'
export const REMOVE_COMMUNITY_DOOR_ACCESS_RESPONSE_ERROR = 'REMOVE_COMMUNITY_DOOR_ACCESS_RESPONSE_ERROR'
export const REMOVE_DOOR_ACCESSES_REQUEST = 'REMOVE_DOOR_ACCESSES_REQUEST'
export const REMOVE_DOOR_ACCESSES_RESPONSE = 'REMOVE_DOOR_ACCESSES_RESPONSE'
export const REMOVE_DOOR_ACCESSES_RESPONSE_ERROR = 'REMOVE_DOOR_ACCESSES_RESPONSE_ERROR'
export const REMOVE_UNIT_DOOR_ACCESS_REQUEST = 'REMOVE_UNIT_DOOR_ACCESS_REQUEST'
export const REMOVE_UNIT_DOOR_ACCESS_RESPONSE = 'REMOVE_UNIT_DOOR_ACCESS_RESPONSE'
export const REMOVE_UNIT_DOOR_ACCESS_RESPONSE_ERROR = 'REMOVE_UNIT_DOOR_ACCESS_RESPONSE_ERROR'
export const SAVE_DOOR_ACCESS_REQUEST = 'SAVE_DOOR_ACCESS_REQUEST'
export const SAVE_DOOR_ACCESS_RESPONSE = 'SAVE_DOOR_ACCESS_RESPONSE'
export const SAVE_DOOR_ACCESS_RESPONSE_ERROR = 'SAVE_DOOR_ACCESS_RESPONSE_ERROR'

// Dialogs
export const SET_DIALOG_EDIT_DOOR_ACCESS_USER = 'SET_DIALOG_EDIT_DOOR_ACCESS_USER'
export const CLEAR_DIALOG_EDIT_DOOR_ACCESS_USER = 'CLEAR_DIALOG_EDIT_DOOR_ACCESS_USER'
export const SET_DIALOG_GRANT_DOOR_ACCESS_USER_IDS = 'SET_DIALOG_GRANT_DOOR_ACCESS_USER_IDS'
export const CLEAR_DIALOG_GRANT_DOOR_ACCESS_USER_IDS = 'CLEAR_DIALOG_GRANT_DOOR_ACCESS_USER_IDS'

// Automations
export const LIST_UNIT_AUTOMATIONS_REQUEST = 'LIST_UNIT_AUTOMATIONS_REQUEST'
export const LIST_UNIT_AUTOMATIONS_RESPONSE = 'LIST_UNIT_AUTOMATIONS_RESPONSE'
export const ADD_UNIT_AUTOMATION_REQUEST = 'ADD_UNIT_AUTOMATION_REQUEST'
export const ADD_UNIT_AUTOMATION_RESPONSE = 'ADD_UNIT_AUTOMATION_RESPONSE'
export const REMOVE_UNIT_AUTOMATION_REQUEST = 'REMOVE_UNIT_AUTOMATION_REQUEST'
export const REMOVE_UNIT_AUTOMATION_RESPONSE = 'REMOVE_UNIT_AUTOMATION_RESPONSE'
export const SAVE_AUTOMATION_REQUEST = 'SAVE_AUTOMATION_REQUEST'
export const SAVE_AUTOMATION_RESPONSE = 'SAVE_AUTOMATION_RESPONSE'

// Subscription
export const FETCH_ALERT_SUBSCRIPTION_REQUEST = 'FETCH_ALERT_SUBSCRIPTION_REQUEST'
export const FETCH_ALERT_SUBSCRIPTION_RESPONSE = 'FETCH_ALERT_SUBSCRIPTION_RESPONSE'

// We use this for caching check to make sure we don't try to load it multiple times.
// Consider using loading indicator state.
export const LOADING_ARRAY = []
LOADING_ARRAY.isLoading = true

export const TIMESERIES_KIND = {
  MEASUREMENT: 'measurement',
  STATE: 'state',
  OCCURRENCE: 'occurrence',
}

// localStorage
export const SHOW_DASHBOARD_INTRO = 'BLOKSENSE_SHOW_DASHBOARD_INTRO'
